// extracted by mini-css-extract-plugin
export default {"logosWrapper":"Logos_logosWrapper__V4-6J","logo":"Logos_logo__S+oDA","delo":"Logos_delo__5XdZO","ncsp":"Logos_ncsp__KfB+W","opas":"Logos_opas__NOvjM"};